import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import authReducer from './slices/authSlice'

const authPersistConfig = {
  key: 'auth',
  storage,
  blacklist: ['isLoading'],
}

const appReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
})

const persistedReducer = persistReducer({ key: 'root', storage }, appReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: import.meta.env.MODE !== 'production',
})

export const persistor = persistStore(store)
